import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBan, faCalendarXmark, faCheckCircle, faCircleMinus, faSheep, faTimer } from '@fortawesome/pro-light-svg-icons';
import { AttendanceStateDto } from '../../api-service/clients';

export function getAttendanceStateIcon(attendanceState?: AttendanceStateDto): IconDefinition {
  switch (attendanceState) {
    case AttendanceStateDto.OnTime:
      return faCheckCircle;
    case AttendanceStateDto.NotOnTime:
      return faTimer;
    case AttendanceStateDto.NotShown:
      return faBan;
    case AttendanceStateDto.AbsenceWithReason:
      return faCircleMinus;
    case AttendanceStateDto.NotRelevant:
      return faCalendarXmark;
    default:
      return faSheep;
  }
}
